// Transaction History (zone account tab and its page) and the Audit Trail (page and nav entry) show
// the same transactions, so one rule gates both. Customers hold it through the ZenithUser role.
export const VIEW_TRANSACTIONS_PERMISSIONS = ["ViewEventTransactions"];
